/* Member portal tab switching. Panels swap without a page load; the active tab
   is written to the URL hash so links and refreshes land in the right place. */
(() => {
  const root = document.querySelector('[data-cloud-portal]');
  if (!root) return;

  const tabs = [...root.querySelectorAll('[data-portal-tab]')];
  const panels = [...root.querySelectorAll('[data-portal-panel]')];
  if (!tabs.length || !panels.length) return;

  const show = (name, updateHash = true) => {
    const target = panels.find((p) => p.dataset.portalPanel === name);
    if (!target) return;

    panels.forEach((p) => {
      const active = p === target;
      p.hidden = !active;
      p.classList.toggle('is-active', active);
    });
    // Only the sidebar buttons carry the active state; dashboard shortcuts don't
    root.querySelectorAll('.cloud-portal__nav [data-portal-tab]').forEach((t) => {
      t.classList.toggle('is-active', t.dataset.portalTab === name);
      t.setAttribute('aria-current', t.dataset.portalTab === name ? 'true' : 'false');
    });
    if (updateHash) history.replaceState(null, '', `#${name}`);
    root.scrollIntoView({ block: 'start', behavior: 'smooth' });
  };

  root.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-portal-tab]');
    if (!trigger) return;
    event.preventDefault();
    show(trigger.dataset.portalTab);
  });

  const initial = window.location.hash.replace('#', '');
  if (initial && panels.some((p) => p.dataset.portalPanel === initial)) show(initial, false);
})();
